import { render, staticRenderFns } from "./RoundStatus.vue?vue&type=template&id=479fc082&scoped=true&"
import script from "./RoundStatus.vue?vue&type=script&lang=js&"
export * from "./RoundStatus.vue?vue&type=script&lang=js&"
import style0 from "./RoundStatus.vue?vue&type=style&index=0&id=479fc082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479fc082",
  null
  
)

export default component.exports